import React from "react";
import SkeletonBlock from "./SkeletonBlock";

const ContentSkeleton: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <SkeletonBlock width="w-1/3" height="h-6" className="mb-6" />
      <SkeletonBlock className="mb-4" />
      <SkeletonBlock width="w-11/12" className="mb-4" />
      <SkeletonBlock width="w-10/12" className="mb-4" />
      <SkeletonBlock width="w-9/12" className="mb-4" />
      <SkeletonBlock width="w-8/12" className="mb-4" />
      <SkeletonBlock width="w-7/12" className="mb-4" />
    </div>
  );
};

export default ContentSkeleton;
